import { render, staticRenderFns } from "./CardPurchaseBuyer.vue?vue&type=template&id=273e6c60&"
import script from "./CardPurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./CardPurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports